import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getMinimumBookingSlots } from '../../Constant.js'
import axios from 'axios'
import ImageCropper from '../../common/ImageCropper/ImageCropper.js'
import GroupCheckbox from '../../common/GroupCheckbox/GroupCheckbox.js'
import ReactQuill from 'react-quill'
import Toggle from 'react-toggle'
import CheckPermission from '../../common/Permissions/CheckPermission'

class BoatsAdd extends React.Component {
  state = {
    status: 'active',
    cruise_name_en: '',
    cruise_name_ar: '',
    cruise_speed: '',
    cruise_pax_capacity: '',
    cruise_desc_en: '',
    cruise_desc_ar: '',
    cruise_price: '0',
    cruise_width: '0',
    cruise_height: '0',
    cruise_fishing_type_en: '',
    cruise_amenities_en: '',
    cruise_fishing_tech_en: '',
    cruise_fishing_type_ar: '',
    cruise_fishing_tech_ar: '',
    cruise_amenities_ar: '',
    cruise_captain_id: '',
    cruise_owner_admin_owner_id: '',
    cruise_master_id: '',

    cruise_facilities: [],
    cruise_trips: [],
    // cruise_activities: [],

    featured: 'true',
    popular_choice: 'false',
    cruise_commission: '',
    minimum_booking_time: '',
    cruise_mobile_number: '',

    facilitiesList: [],
    tripsList: [],
    // activitiesList: [],

    isSaving: false,
    isData: false,
    Edit: false,

    max_guests: '0',
    big_lounges: '0',
    bedrooms: '0',
    toilets: '0',

    cruise_popular_choice_img: '',
    cruise_large_img: '',

    policy_en: '',
    policy_ar: '',
    refund_policy_en: '',
    refund_policy_ar: '',
    vat_registered: false,
    vat_amount: null,

    meta_title_en: '',
    meta_title_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    h1_ar: '',
    h1_en: '',
    h2_ar: '',
    h2_en: '',
    b2c_commission_type: '',
    b2b_commission_type: '',
    b2b_commission: '',
    b2c_commission: '',
    book_by: '',
  }

  componentDidMount() {
    setTimeout(() => {
      this.getBoatOwnerDetails()
      this.getCategoryMaster()
      this.getFacilitiesList()
      this.getTripsList()
      // this.getActivitiesList(); // need to delete activities from add edit boat
      if (this.props.boatId) this.getCruiseList()
    }, 100)
  }

  getBoatOwnerDetails = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + '/admin/list-users/admin', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Owner_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getCategoryMaster = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/cruise/list-cruise-masters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          let categoryListCopy = res.data.data.filter((category) => category.is_active === true)
          that.setState({
            categoryList: categoryListCopy,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getFacilitiesList = () => {
    axios
      .get(Constant.getAPI() + `/admin/get-facilities/cruise`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            facilitiesList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getTripsList = () => {
    axios
      .get(Constant.getAPI() + `/admin/trip`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            tripsList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  // getActivitiesList = () => {
  // 	axios.get(Constant.getAPI() + `/admin/activity`, {
  // 		headers: {
  // 			"Content-Type": "application/json",
  // 			Authorization: `Bearer ${localStorage.getItem("loged_In_auth")}`,
  // 			country_short_name: `${localStorage.getItem("countryShortName")}`,
  // 		},
  // 	}).then(res => {
  // 		if (res.data.success) {
  // 			this.setState({
  // 				activitiesList: res.data.data
  // 			})
  // 		}
  // 	}).catch(err => {
  // 		if (err?.response?.status === 401) {
  // 			Constant.getAuthLogout();
  // 		} else {
  // 			Swal.fire({
  // 				title:
  // 					err?.response?.data?.data?.details?.[0]?.message ||
  // 					err?.response?.data?.message,
  // 				icon: "error",
  // 				text: "",
  // 				type: "error",
  // 				confirmButtonColor: "#3085d6",
  // 				cancelButtonColor: "#d33",
  // 				confirmButtonText: "Ok",
  // 			});
  // 		}
  // 	})
  // }

  handleChange = (event, name) => {
    if (
      (event?.target?.name === 'cruise_price' ||
        event?.target?.name === 'cruise_width' ||
        event?.target?.name === 'cruise_height') &&
      !(event?.target?.value >= 0)
    ) {
      return
    }

    if (name === 'cruise_facilities') {
      this.setState({ cruise_facilities: event })
      return
    } else if (event.target.name === 'cruise_trips' || event.target.name === 'cruise_activities') {
      if (event.target.value !== '') {
        /* eslint-disable no-unsafe-optional-chaining */
        this.setState({
          [event.target.name]: ([...this.state[event.target.name]] = this.state[event.target.name]?.filter(
            (item) => item !== ''
          )),
        })
      }

      if (event.target.value === '') {
        this.setState({ [event.target.name]: [event.target.value] })
      } else if (this.state[event.target.name]?.includes(event.target.value)) {
        this.setState({
          [event.target.name]: ([...this.state[event.target.name]] = this.state[event.target.name]?.filter(
            (item) => item !== event.target.value
          )),
        })
      } else {
        this.setState({ [event.target.name]: [...this.state[event.target.name], event.target.value] })
      }
      return
    }

    this.setState({ [event.target.name]: event.target.value })
    if (event.target.name === 'cruise_owner_admin_owner_id') {
      let id_Captain = event.target.value
      this.getCaptainDetails(id_Captain)
    }

    if (event.target.name == 'vat_registered') {
      this.setState({ vat_registered: event.target.checked })
    }
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({
      [imgKeyName]: e,
      Edit: false,
    })

    if (imgKeyName == 'cruise_popular_choice_img') {
      this.setState({ popular_img: URL.createObjectURL(e) })
    } else {
      this.setState({ img: URL.createObjectURL(e) })
    }
  }

  onSaveDataBoat = () => {
    var that = this
    if (this.state.b2b_commission_type && (!this.state.b2b_commission || this.state.b2b_commission == 0)) {
      document.getElementById('b2b_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2B commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    if (this.state.b2c_commission_type && (!this.state.b2c_commission || this.state.b2c_commission == 0)) {
      document.getElementById('b2c_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2C commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    const formData = new FormData()

    formData.append('cruise_name_en', this.state.cruise_name_en)
    formData.append('cruise_name_ar', this.state.cruise_name_ar)
    formData.append('cruise_speed', this.state.cruise_speed)
    formData.append('cruise_pax_capacity', this.state.cruise_pax_capacity)
    formData.append('cruise_desc_en', this.state.cruise_desc_en)
    formData.append('cruise_desc_ar', this.state.cruise_desc_ar)
    formData.append('cruise_price', this.state.cruise_price)
    formData.append('cruise_width', this.state.cruise_width)
    formData.append('cruise_height', this.state.cruise_height)
    formData.append('cruise_fishing_type_en', this.state.cruise_fishing_type_en)
    formData.append('cruise_amenities_en', this.state.cruise_amenities_en)
    formData.append('cruise_fishing_tech_en', this.state.cruise_fishing_tech_en)
    formData.append('cruise_fishing_type_ar', this.state.cruise_fishing_type_ar)
    formData.append('cruise_fishing_tech_ar', this.state.cruise_fishing_tech_ar)
    formData.append('cruise_amenities_ar', this.state.cruise_amenities_ar)
    formData.append('cruise_captain_id', this.state.cruise_captain_id)
    formData.append('cruise_owner_admin_owner_id', this.state.cruise_owner_admin_owner_id)
    formData.append('cruise_master_id', this.state.cruise_master_id)
    formData.append('featured', this.state.featured)
    formData.append('popular_choice', this.state.popular_choice)
    formData.append('cruise_commission', this.state.cruise_commission)
    formData.append('minimum_booking_time', this.state.minimum_booking_time)
    formData.append('cruise_mobile_number', this.state.cruise_mobile_number)
    formData.append('cruise_facilities', this.state.cruise_facilities)
    formData.append('cruise_trips', this.state.cruise_trips)
    formData.append('book_by', this.state.book_by || 'hour')

    formData.append('max_guests', this.state.max_guests)
    formData.append('big_lounges', this.state.big_lounges)
    formData.append('bedrooms', this.state.bedrooms)
    formData.append('toilets', this.state.toilets)

    formData.append('policy_en', this.state.policy_en)
    formData.append('policy_ar', this.state.policy_ar)
    formData.append('refund_policy_en', this.state.refund_policy_en)
    formData.append('refund_policy_ar', this.state.refund_policy_ar)
    formData.append('vat_registered', this.state.vat_registered)
    formData.append('vat_amount', this.state.vat_amount)

    formData.append('meta_title_en', this.state.meta_title_en)
    formData.append('meta_title_ar', this.state.meta_title_ar)
    formData.append('meta_desc_en', this.state.meta_desc_en)
    formData.append('meta_desc_ar', this.state.meta_desc_ar)
    formData.append('meta_keywords_en', this.state.meta_keywords_en)
    formData.append('meta_keywords_ar', this.state.meta_keywords_ar)
    formData.append('h1_ar', this.state.h1_ar)
    formData.append('h1_en', this.state.h1_en)
    formData.append('h2_ar', this.state.h2_ar)
    formData.append('h2_en', this.state.h2_en)

    formData.append('b2b_commission_type', this.state.b2b_commission_type || '')
    formData.append('b2b_commission', this.state.b2b_commission || '')
    formData.append('b2c_commission_type', this.state.b2c_commission_type || '')
    formData.append('b2c_commission', this.state.b2c_commission || '')

    that.setState({ isData: true })

    if (this.state.cruise_popular_choice_img?.type) {
      formData.append('cruise_popular_choice_img', this.state.cruise_popular_choice_img, 'your_original_filename.jpeg')
    }
    if (this.state.cruise_large_img?.type) {
      formData.append('cruise_large_img', this.state.cruise_large_img, 'your_original_filename.jpeg')
    }

    if (this.props.boatId) {
      formData.append('cruise_id', this.props.boatId)

      axios
        .put(Constant.getAPI() + '/cruise/update-cruise', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `${that.props.boatType} has been Updated`, 'success')
            window.history.back()
            // window.location.href = `#/boatsmaster/${that.props.boatType}`;
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/cruise/add-cruise', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `${that.props.boatType} has been Added`, 'success')
            window.history.back()
            // window.location.href = `#/boatsmaster/${that.props.boatType}`;
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  getCaptainDetails = async (id_Captain) => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/captain/owner-alloted-captains/${id_Captain}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Captain_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getCruiseList = async () => {
    await axios
      .get(Constant.getAPI() + `/cruise/get-cruise/${this.props.boatId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const item = res.data.data

          if (item.cruise_owner_admin_owner_id) {
            var owner_id = item.cruise_owner_admin_owner_id
            this.getCaptainDetails(owner_id)
          }

          this.setState({
            ...item,
            cruise_width: parseFloat(item.cruise_width),
            cruise_height: parseFloat(item.cruise_height),
            Edit: true,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">{this.props.boatType} Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="cruise_name_en"
                    id="cruise_name_en"
                    placeholder={`${this.props.boatType}Name:English`}
                    onChange={this.handleChange}
                    value={this.state.cruise_name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">{this.props.boatType} Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="cruise_name_ar"
                    id="cruise_name_ar"
                    placeholder={`${this.props.boatType}Name:Arabic`}
                    onChange={this.handleChange}
                    value={this.state.cruise_name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">{this.props.boatType} Category</label>
                <div className="col-sm-9">
                  <select
                    name="cruise_master_id"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.cruise_master_id}
                  >
                    <option>Select {this.props.boatType} Category</option>
                    {this.state.categoryList !== undefined &&
                      this.state.categoryList !== null &&
                      this.state.categoryList !== [] &&
                      this.state.categoryList.length > 0
                      ? this.state.categoryList.map((categoryList) => (
                        <option
                          value={categoryList.id}
                          key={categoryList.id}
                        >
                          {categoryList.cruise_cat_en}
                        </option>
                      ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Owner Name</label>
                <div className="col-sm-9">
                  <select
                    name="cruise_owner_admin_owner_id"
                    className="form-control"
                    value={this.state.cruise_owner_admin_owner_id}
                    onChange={this.handleChange}
                  >
                    <option>Select Owner</option>
                    {this.state.Owner_list !== undefined &&
                      this.state.Owner_list !== null &&
                      this.state.Owner_list !== [] &&
                      this.state.Owner_list.length > 0
                      ? this.state.Owner_list.map((Owner_list) => (
                        <option
                          value={Owner_list.id}
                          key={Owner_list.id}
                        >
                          {Owner_list.first_name}
                          {Owner_list.last_name}
                        </option>
                      ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Captain Name</label>
                <div className="col-sm-9">
                  <select
                    name="cruise_captain_id"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.cruise_captain_id}
                  >
                    <option>Select Category</option>
                    {this.state.Captain_list !== undefined &&
                      this.state.Captain_list !== null &&
                      this.state.Captain_list !== [] &&
                      this.state.Captain_list.length > 0
                      ? this.state.Captain_list.map((Captain_list) => (
                        <option
                          value={Captain_list.id}
                          key={Captain_list.id}
                        >
                          {Captain_list.first_name}
                          {Captain_list.last_name}
                        </option>
                      ))
                      : null}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Booking By</label>
                <div className="col-sm-9">
                  <select
                    name="book_by"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.book_by}
                  >
                    <option value="">Select Booking By</option>
                    <option value="day">Day</option>
                    <option value="hour">Hour</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Vat Registered</label>
                <div className="col-sm-1">
                  <Toggle
                    className="ml-2 form-control"
                    name="vat_registered"
                    id="vat_registered"
                    onChange={this.handleChange}
                    checked={this.state.vat_registered}
                  />
                </div>
              </div>
            </div>
            {this.state.vat_registered && (
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">
                    Vat Amount %<br />
                    <span style={{ color: 'red', fontSize: '10px' }}>(Only showing in reports)</span>
                  </label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      type="number"
                      onChange={this.handleChange}
                      name="vat_amount"
                      id="vat_amount"
                      placeholder="Vat Amount %"
                      value={this.state.vat_amount}
                      min={0}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Cruise Mobile Number</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="cruise_mobile_number"
                    id="cruise_mobile_number"
                    placeholder="mobile number"
                    value={this.state.cruise_mobile_number}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Minimum Booking Time</label>
                <div className="col-sm-9">
                  <select
                    name="minimum_booking_time"
                    className="form-control"
                    value={this.state.minimum_booking_time}
                    onChange={this.handleChange}
                  >
                    <option>Select time(HH:MM)</option>
                    {getMinimumBookingSlots().map(
                      (item) =>
                        item.value != '00:00:00' && (
                          <option
                            value={item.value}
                            key={item.value}
                          >
                            {item.label}
                          </option>
                        )
                    )}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Pax Capacity</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="cruise_pax_capacity"
                    id="cruise_pax_capacity"
                    placeholder="Pax Capacity"
                    onChange={this.handleChange}
                    value={this.state.cruise_pax_capacity}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Size(ft)</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="cruise_width"
                    id="cruise_width"
                    placeholder="Width"
                    onChange={this.handleChange}
                    value={this.state.cruise_width}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Speed</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="cruise_speed"
                    id="cruise_speed"
                    placeholder="Speed"
                    onChange={this.handleChange}
                    value={this.state.cruise_speed}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Guests</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="max_guests"
                    id="max_guests"
                    placeholder="In percentage 1 to 100"
                    value={this.state.max_guests}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Big Lounges</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="big_lounges"
                    id="big_lounges"
                    placeholder="In percentage 1 to 100"
                    value={this.state.big_lounges}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Bedrooms</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="bedrooms"
                    id="bedrooms"
                    placeholder="In percentage 1 to 100"
                    value={this.state.bedrooms}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Toilets</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="toilets"
                    id="toilets"
                    placeholder="In percentage 1 to 100"
                    value={this.state.toilets}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Fishing type: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="cruise_fishing_type_en"
                    id="cruise_fishing_type_en"
                    placeholder="type1,type2,type3"
                    onChange={this.handleChange}
                    value={this.state.cruise_fishing_type_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Fishing type: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="cruise_fishing_type_ar"
                    id="cruise_fishing_type_ar"
                    placeholder="type1,type2,type3"
                    onChange={this.handleChange}
                    value={this.state.cruise_fishing_type_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Fishing tech: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="cruise_fishing_tech_en"
                    id="cruise_fishing_tech_en"
                    placeholder="tech1,tech2,tech3"
                    onChange={this.handleChange}
                    value={this.state.cruise_fishing_tech_en}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Fishing tech: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="cruise_fishing_tech_ar"
                    id="cruise_fishing_tech_ar"
                    placeholder="tech1,tech2,tech3"
                    onChange={this.handleChange}
                    value={this.state.cruise_fishing_tech_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Amenities: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="cruise_amenities_en"
                    id="cruise_amenities_en"
                    placeholder="amen1,amen2,amen3"
                    onChange={this.handleChange}
                    value={this.state.cruise_amenities_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Amenities: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="cruise_amenities_ar"
                    id="cruise_amenities_ar"
                    placeholder="amen1,amen2,amen3"
                    onChange={this.handleChange}
                    value={this.state.cruise_amenities_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="cruise_desc_en"
                    id="cruise_desc_en"
                    value={this.state.cruise_desc_en}
                    onChange={(value) => {
                      this.setState({
                        cruise_desc_en: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="cruise_desc_ar"
                    id="cruise_desc_ar"
                    value={this.state.cruise_desc_ar}
                    onChange={(value) => {
                      this.setState({
                        cruise_desc_ar: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Policy: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="policy_en"
                    id="policy_en"
                    value={this.state.policy_en}
                    onChange={(value) => {
                      this.setState({
                        policy_en: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Policy: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="policy_ar"
                    id="policy_ar"
                    value={this.state.policy_ar}
                    onChange={(value) => {
                      this.setState({
                        policy_ar: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Refund Policy: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="refund_policy_en"
                    id="refund_policy_en"
                    value={this.state.refund_policy_en}
                    onChange={(value) => {
                      this.setState({
                        refund_policy_en: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Refund Policy: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="refund_policy_ar"
                    id="refund_policy_ar"
                    value={this.state.refund_policy_ar}
                    onChange={(value) => {
                      this.setState({
                        refund_policy_ar: value,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group row">
                <label className="col-3 col-form-label">Trips</label>
                <div className="col-9">
                  <select
                    multiple
                    name="cruise_trips"
                    className="form-control"
                    value={this.state.cruise_trips}
                    onChange={this.handleChange}
                  >
                    {this.state.tripsList.map((item) => (
                      <option
                        value={item.id}
                        key={item.id}
                      >
                        {item.name_en} / {item.name_ar}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Popular Choice</label>
                <div className="col-sm-9">
                  <select
                    name="popular_choice"
                    className="form-control"
                    value={this.state.popular_choice}
                    onChange={this.handleChange}
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>
                </div>
              </div>
            </div>
            <CheckPermission permission={'edit-commission'}>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              >
                <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Commission</div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">B2B Commission Type</label>
                  <div className="col-sm-9">
                    <select
                      name="b2b_commission_type"
                      className="form-control"
                      value={this.state.b2b_commission_type}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Option</option>
                      <option value="percentage">Percentage</option>
                      <option value="amount">Amount</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">B2B Commission</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      type="number"
                      onChange={this.handleChange}
                      name="b2b_commission"
                      id="b2b_commission"
                      // placeholder="In percentage 1 to 100"
                      value={this.state.b2b_commission}
                      min={0}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">B2C Commission Type</label>
                  <div className="col-sm-9">
                    <select
                      name="b2c_commission_type"
                      className="form-control"
                      value={this.state.b2c_commission_type}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Option</option>
                      <option value="percentage">Percentage</option>
                      <option value="amount">Amount</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">B2C Commission</label>
                  <div className="col-sm-9">
                    <input
                      className="form-control"
                      type="number"
                      onChange={this.handleChange}
                      name="b2c_commission"
                      id="b2c_commission"
                      // placeholder="In percentage 1 to 100"
                      value={this.state.b2c_commission}
                      min={0}
                    />
                  </div>
                </div>
              </div>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              ></div>
            </CheckPermission>
            <div className="col-12">
              <GroupCheckbox
                title={'Facilities'}
                list={this.state.facilitiesList}
                displayKey={'name_en'}
                idKey={'id'}
                selected={this.state.cruise_facilities}
                onChange={(event) => this.handleChange(event, 'cruise_facilities')}
              ></GroupCheckbox>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>
            {/* <div className="col-6">
							<div className="form-group row">
								<label className="col-3 col-form-label">Activities</label>
								<div className="col-9">
									<select
										multiple
										name="cruise_activities"
										className="form-control"
										value={this.state.cruise_activities}
										onChange={this.handleChange}
									>
										{
											this.state.activitiesList.map((item) => (
												<option value={item.id} key={item.id}>
													{item.name_en} / {item.name_ar}
												</option>
											))
										}
									</select>
								</div>
							</div>
						</div> */}
            <div className="col-md-12"></div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">{`${this.props.boatType}`} Grid View Image</div>
                <div className="col-sm-6">
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.cruise_large_img || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'cruise_large_img')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Popular Choice or List View Image</div>
                <div className="col-sm-6">
                  <ImageCropper
                    ratio={17 / 10}
                    img={this.state.cruise_popular_choice_img || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'cruise_popular_choice_img')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <CheckPermission permission={'manage-meta-tags'}>
              <>
                <div
                  className="col-md-12"
                  style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                >
                  <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Meta Settings</div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Meta Title: English</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="meta_title_en"
                        id="meta_title_en"
                        placeholder=""
                        onChange={this.handleChange}
                        value={this.state.meta_title_en}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="meta_title_ar"
                        id="meta_title_ar"
                        placeholder=" "
                        onChange={this.handleChange}
                        value={this.state.meta_title_ar}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Meta keywords: English</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="meta_keywords_en"
                        id="meta_keywords_en"
                        placeholder=""
                        onChange={this.handleChange}
                        value={this.state.meta_keywords_en}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Meta keywords: Arabic</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="meta_keywords_ar"
                        id="meta_keywords_ar"
                        placeholder=""
                        onChange={this.handleChange}
                        value={this.state.meta_keywords_ar}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Meta Description: English</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="meta_desc_en"
                        id="meta_desc_en"
                        value={this.state.meta_desc_en}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="meta_desc_ar"
                        id="meta_desc_ar"
                        value={this.state.meta_desc_ar}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">H1: English</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="h1_en"
                        id="h1_en"
                        placeholder="H1: English"
                        onChange={this.handleChange}
                        value={this.state.h1_en}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">H1: Arabic</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="h1_ar"
                        id="h1_ar"
                        placeholder="H1: Arabic"
                        onChange={this.handleChange}
                        value={this.state.h1_ar}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">H2: English</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="h2_en"
                        id="h2_en"
                        placeholder="H2: English"
                        onChange={this.handleChange}
                        value={this.state.h2_en}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">H2: Arabic</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        name="h2_ar"
                        id="h2_ar"
                        placeholder="H2: Arabic"
                        onChange={this.handleChange}
                        value={this.state.h2_ar}
                      />
                    </div>
                  </div>
                </div>
              </>
            </CheckPermission>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveDataBoat}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={`/boatsmaster/${this.props.boatType}`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default BoatsAdd
